import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React, { PropsWithChildren } from 'react';

import ButtonComponent from '#app/Component/ButtonComponent';

type Props = {
  title: string;
  loading: boolean;
  onClose: () => void;
  onSubmit: () => void;
};

const Modal: React.FC<PropsWithChildren<Props>> = ({ title, loading, onClose, onSubmit, children }) => {
  const classes = useStyles();

  return (
    <Dialog open maxWidth="xl" onClose={onClose}>
      <DialogTitle className={classes.title}>{title}</DialogTitle>
      <DialogContent className={classes.content}>{children}</DialogContent>
      <DialogActions>
        <ButtonComponent color="#5E6E82" label="Annuler" onClick={onClose} disabled={loading} />
        <ButtonComponent label="Valider" loading={loading} onClick={onSubmit} />
      </DialogActions>
    </Dialog>
  );
};

const useStyles = makeStyles({
  title: {
    fontSize: 15,
  },
  content: {
    minWidth: 300,
    width: '90vw',
    maxWidth: 600,
  },
});

export default Modal;
